/**
 * Navigation
 */
require("waypoints");
require("waypoints-sticky");

const $ = require('jquery');

const sticky = new Waypoint.Sticky({
  element: $('.menu__main')[0]
});

$('.hamburger').on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  this.classList.toggle("is-active");
  $('.navigation__main').toggleClass("is-visible");
});


$(document).click(function(event) {
  if(!$(event.target).closest('.navigation__main').length) {
    if($('.navigation__main').hasClass("is-visible")) {
      $('.navigation__main').removeClass('is-visible');
      $('.hamburger').removeClass("is-active");
    }
  }
});
